jQuery(document).ready(function ($) {
    const container = $('.related-properties__container[data-property-id]');

    if (!container.length) return;

    function fetchRelatedProperties() {
        $.ajax({
            url: properties.ajax_url,
            type: 'POST',
            data: {
                action: 'get_related_properties',
                property_id: container.attr('data-property-id'),
                nonce: properties.nonce
            },

            beforeSend: function () {
                container.show();
                container.find('.loading').fadeIn(250);
            },

            success: function (response) {
                if (!response.success || !response.data.count) {
                    container.hide();
                    return;
                }

                container.find('.related-properties__wrapper').html(response.data.html);

                container.find('.js-property-item').each(function () {
                    new Swiper(`.js-property-item[data-property-id="${$(this).attr('data-property-id')}"]`, {
                        loop: true,
                        slidesPerView: 1,
                        autoplay: true,
                        delay: 3000,
                        navigation: {
                            prevEl: '.property-item__prev',
                            nextEl: '.property-item__next'
                        },
                        pagination: {
                            el: '.property-item__pagination',
                            bulletClass: 'property-item__bullet',
                            bulletActiveClass: 'active'
                        },
                        slideClass: 'property-item__image',
                        on: {
                            slideChange: function (swiper) {
                                var img = swiper.slides[swiper.activeIndex].querySelector('img[data-src]');
                                if (img) { img.src = img.dataset.src; img.removeAttribute('data-src'); }
                            }
                        }
                    });
                });

                new Swiper('.js-related-properties', {
                    loop: true,
                    slidesPerView: 1,
                    slidesPerGroup: 1,
                    autoplay: true,
                    delay: 8000,
                    spaceBetween: 16,
                    slideClass: 'property-item',
                    breakpoints: {
                        480: { slidesPerView: 2 },
                        768: { slidesPerView: 3 },
                        1024: { slidesPerView: 4 }
                    }
                });
            },

            complete: function () {
                container.find('.loading').fadeOut(250);
            }
        });
    }

    const observer = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        fetchRelatedProperties();
    }, { rootMargin: '0px 0px 400px 0px' });

    observer.observe(container.closest('.related-properties')[0]);
});